module.exports = __webpack_public_path__ + "img/main-logo.b0ac40a2.png";